import React from 'react';
import { Spacer, PageContent, Query, PenlySeo } from 'components';

import TERMS_PAGE_QUERY from 'queries/pages/terms';

export default function Terms() {
    const title = 'Teals brugervilkår for Penly';
    const description = '';
    const image = { url: '/static/gfx/content/penly-content-5.jpg' };

    return (
    // <Query query={ TERMS_PAGE_QUERY }>
    //     { ({ data: { termsPage } }) => {
    //         return <PageContent { ...termsPage.content } />;
    //     } }
    // </Query>
        <>
            <PenlySeo title={ title } description={ description } image={ image } />
            <article>
                <h1>Teals brugervilkår for Penly</h1>
                <div className="date">Version 1.1, opdateret den 17. marts 2021</div>

                <h4>Anvendelsesområde</h4>
                <p>
                    Brugervilkårene gælder Teals hjemmesider, apps, sociale medier og andre digitale platforme, som Teal benytter.
                    Teal’s privatlivspolitik gælder endvidere når Penly benyttes.
                </p>

                <h4>Om Penly</h4>
                <p>
                    Penly er en tjeneste der udbydes af Teal. Penly lader dig:
                </p>
                <ul>
                    <li>oprette en profil</li>
                    <li>uploade dine finansielle dokumenter (herefter &quot;Dokumenter&quot;)</li>
                    <li>opbevare dine Dokumenter</li>
                    <li>dele Dokumenter med en tredje part og benytte de ydelser og funktioner som Penly til enhver tid måtte tilbyde evt. i kraft af
                        Penlys samarbejde med tredjeparter.</li>
                </ul>

                <h4>Ansvarsbegrænsning</h4>
                <p>
                    Medmindre andet følger af ufravigelig lovgivning, er Teal ikke ansvarlig for indholdet af dine Dokumenter eller adviseringer,
                    og heller ikke for tab ved forsinkelse, manglende levering, fejllevering, tab af data, IT-fejl, virus, skade på dit udstyr,
                    eller force majeure lignende forhold, uanset om det alene angår Teal. Teal er ikke ansvarlig for tab som følge af uberettiget brug,
                    f.eks. hvis der er blevet givet adgang til andre til din Penly profil hos Teal, eller du har undladt at underrette Teal om uregelmæssigheder
                    eller misbrug eller mistanke herom.
                </p>

                <h4>Inaktivitet og dødsfald</h4>
                <p>
                    Ved dødsfald forbeholder Teal sig ret til efter 15 måneder at slette afdødes oplysninger hos Teal. Det samme gør sig gældende, hvis du ikke har
                    benyttet Penly i over 2 år.
                </p>

                <h4>Vilkårsændringer</h4>
                <p>
                    Teal kan ændre og opdatere vilkårene for brug af Penly ved annoncering på Penly.dk, hvor de gældende vilkår altid vil være tilgængelige.
                    Ved væsentlige ændringer eller indskrænkninger, gives meddelelse via Penly med mindst en måneds varsel.
                </p>

                <h4>Rettigheder</h4>
                <p>
                    Alt materiale i Penly, f.eks. navne, logoer, varemærker, grafik, tekster, ikoner, billeder, software mv., tilhører Teal og samarbejdspartnere
                    og er beskyttet af bl.a. varemærke-, ophavsrets- og markedsføringslovgivningen.
                </p>

                <h4>Lovvalg og værneting</h4>
                <p>
                    Tvister vedr. forhold reguleret af disse vilkår skal afgøres efter dansk ret ved de danske domstole.
                </p>

                <h4>Kontakt</h4>
                <p>
                    <strong>Penly</strong><br />
                    Symbion<br />
                    Fruebjergvej 3<br />
                    2100 København Ø<br />
                    <a href="mailto:kontakt@penly.dk">kontakt@penly.dk</a>
                </p>

                <h4>Din Penly profil hos Teal</h4>
                <p>
                    Med en Penly profil hos Teal kan du uploade og dele dine finansielle dokumenter. Følgende vilkår er gældende,
                    ved oprettelse af et sådan Penly hos Teal.
                </p>

                <h4>Udveksling af dine oplysninger</h4>
                <p>
                    De Dokumenter du uploader på Penly platformen anses for at være dine. Når du deler dine Dokumenter med en tredjepart via Penly hos
                    Teal betragtes adgangen til dine data som et forhold mellem dig og tredjeparten, og ikke mellem Teal og tredjeparten.
                    Dette gælder også, når du på opfordring fra en tredjepart opretter en Penly profil samt uploader dine Dokumenter.
                    Teal er ikke ansvarlig for hvem du deler dine Dokumenter med, og hvordan trejdeparter benytter dine Dokumenter.
                </p>

                <h4>Sletning</h4>
                <p>
                    Sletter du Dokumenter fra din profil, kan de ikke genoprettes eller genskabes. Du kan til enhver tid slette Dokumenter gemt
                    i din Penly profil hos Teal. Teal forbeholder sig retten til at gøre Dokumenter som du uploader til din konto, utilgængelige,
                    i tilfælde hvor Teal er underlagt en retlig forpligtelse, og hvor der fejlagtigt er sket en kompromittering af andres personoplysninger.
                </p>


                <h4>Dit ansvar</h4>
                <p>
                    Du skal a) sikre, at Teal altid har din korrekte e-mailadresse, hvis du ønsker advisering om nye vigtige meddelelser, og b) straks skifte
                    adgangskode og underrette Teal, hvis du bliver opmærksom på eller får mistanke om uregelmæssigheder eller misbrug af din Penly profil hos Teal.
                    Du er i øvrigt ansvarlig for at alt indhold, som du uploader i til din Penly profil, overholder gældende dansk lovgivning.
                </p>
            </article>
        </>
    );
}
